import Cookie from 'cookie-universal'
import { ONE_DAY } from '@mc/constants'
import { segment, identify, track } from '@mc/track-event'
import request, {
  isSuccessful,
  needsConfirmation,
  getError,
} from './authApiService'
import { redirect } from './authService'

const cookies = Cookie()

export const googleOneTapAuth = ({
  credential,
  onLogIn,
  redirectTo,
}: {
  credential: string
  onLogIn?: () => void
  redirectTo?: string
}) => {
  // Set last_mc_url to have redirectTo path after log in
  cookies.set('last_mc_url', redirectTo || window.location.href, {
    encode: (e: string) => e,
    maxAge: ONE_DAY,
    path: '/',
  })

  return request('/auth/google_one_tap/callback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ credential }),
  })
    .then((res) => {
      if (isSuccessful(res)) {
        const { email, userId, newUser } = res
        const location = 'log_in_flyout'
        identify(userId, { email, location })

        if (newUser) {
          track(segment.EventTypes.ACCOUNT_CREATED, {
            email,
            userId,
            location,
          })
        }

        onLogIn?.()
        redirect(res)

        return res
      }
      if (needsConfirmation(res)) {
        return res
      }
      throw getError()
    })
    .catch((e) => {
      throw e
    })
}
